<template>
  <v-list :class="listClass">
    <ChangeLanguageButton @click="emit('open-languages')" />
    <SideMenuListItem
      v-if="!hideTownSelect"
      icon="ui-icon-map-pin"
      data-qa="active_town"
      :title="townTitle"
      :title-class="townTitleClass"
      @click="emit('open-town')"
    />

    <v-divider
      v-if="isRealPatient || isAnonymous"
      inset
    />

    <SideMenuListItem
      v-if="primaryUserItem"
      :icon="primaryUserItem.icon"
      :href="primaryUserItem.href"
      :title="primaryUserItem.label"
    />

    <template v-else>
      <SideMenuListItem
        v-for="item in guestAuthItems"
        :key="item.key"
        :icon="item.icon"
        :data-qa="item.qa"
        :title="item.label"
        @click="item.onClick?.()"
      />

      <template v-if="!isYDoc">
        <v-divider inset />

        <SideMenuListItem
          v-for="item in expertItems"
          :key="item.key"
          :icon="item.icon"
          :data-qa="item.qa"
          :title="item.label"
          @click="item.onClick?.()"
        />
      </template>
    </template>

    <template v-if="isRealPatient">
      <ClubCardListItem @click="emit('click-card-info')" />
      <SideMenuListItem
        v-for="item in patientCabinetItems"
        :key="item.key"
        :icon="item.icon"
        :href="item.href"
        :title="item.label"
        :subtitle="item.subtitle"
        :subtitle-class="item.key === 'cabinet-medcard' ? 'text-body-2 error--text' : 'text-body-2 text-info--text'"
      />
      <LogoutListItem @click="emit('logout')" />
    </template>

    <v-divider
      v-if="isRealPatient || isAnonymous"
      inset
    />

    <SideMenuListItem
      v-if="projects"
      icon="ui-icon-more-projects"
      data-qa="other_projects"
      :title="projectsTitle"
      @click="emit('open-projects')"
    />
  </v-list>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import { translate } from 'src/layouts/core-layout/_functions/translate'
import ChangeLanguageButton from 'src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/components/ChangeLanguageButton.vue'
import ClubCardListItem from 'src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/components/ClubCardListItem.vue'
import LogoutListItem from 'src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/components/LogoutListItem.vue'
import SideMenuListItem from 'src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/components/SideMenuListItem.vue'
import useSideMenuItems from 'src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/composables/useSideMenuItems'
import useSideMenuMedcard from 'src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/composables/useSideMenuMedcard'
import useSideMenuTownSnackbar from 'src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/composables/useSideMenuTownSnackbar'
import type { SideMenuProps } from 'src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/SideMenu.types'

const props = withDefaults(defineProps<{
  listClass?: string | string[]
  hideTownSelect?: boolean
  town?: string
  townSelectUrl?: string
  expertUrl?: string
  personalAreaUrl?: string
  projects?: SideMenuProps['projects']
}>(), {
  listClass: () => [],
  hideTownSelect: false,
  town: '',
  townSelectUrl: '',
  expertUrl: '',
  personalAreaUrl: '',
  projects: undefined,
})

const emit = defineEmits(['open-languages', 'open-projects', 'open-town', 'logout', 'click-card-info'])

const projectsTitle = computed(() => translate('Наши проекты'))

const {
  hideTownSelect,
  town,
  townSelectUrl,
  expertUrl,
  personalAreaUrl,
  projects,
} = toRefs(props)

const { medcardStatusText } = useSideMenuMedcard()

const {
  isRealPatient,
  isAnonymous,
  isYDoc,
  primaryUserItem,
  townTitle,
  townTitleClass,
  guestAuthItems,
  expertItems,
  patientCabinetItems,
} = useSideMenuItems({
  town,
  expertUrl,
  personalAreaUrl,
  medcardStatusText,
})

useSideMenuTownSnackbar(town, townSelectUrl)
</script>
